import { connect } from "react-redux";
import OvTimeView from "./OvTimeView";
import moment from "moment";

const calculateGranularity = (hours, maxSlots) => {
  if (hours > 24 * 7 * maxSlots) {
    return { unit: "month", count: 1 };
  }
  if (hours > 24 * maxSlots) {
    return { unit: "week", count: 1 };
  }
  if (hours > 12 * maxSlots) {
    return { unit: "day", count: 1 };
  }
  if (hours > 6 * maxSlots) {
    return { unit: "hour", count: 12 };
  }
  if (hours > 3 * maxSlots) {
    return { unit: "hour", count: 6 };
  }
  if (hours > 1 * maxSlots) {
    return { unit: "hour", count: 3 };
  }
  return { unit: "hour", count: 1 };
};

const quantize = (time, unit, count) => {
  const newTime = moment.utc(time);
  if (unit === "hour") {
    count = parseInt(count, 10);
    const h = Math.floor(time.hour() / count) * count;
    return newTime
      .hour(h)
      .minutes(0)
      .seconds(0)
      .milliseconds(0);
  }

  return newTime.startOf(unit);
};

const makeEmptySeries = (data, unit, count) => {
  const firstTime = quantize(moment.utc(data[0].start_time), unit, count);
  const lastTime = quantize(
    moment.utc(data[data.length - 1].start_time),
    unit,
    count
  );

  if (data.length === 1) {
    firstTime.subtract(count, `${unit}s`);
  }

  const result = [];
  for (
    let currTime = firstTime;
    currTime.isSameOrBefore(lastTime, "hour");
    currTime = currTime.add(count, unit)
  ) {
    const timestamp = currTime.valueOf();

    const emptyWithTime = {
      cores: 0,
      instance_cost: 0,
      license_cost: 0,
      minutes: 0,
      start_time: moment.utc(timestamp),
      storage: 0,
      storage_cost: 0,
      timestamp
    };

    result.push(emptyWithTime);
  }

  return result;
};

const groupData = (data, unit, count) => {
  const empties = makeEmptySeries(data, unit, count);

  let curr = 0;
  empties.forEach(empty => {
    let slotFinished = false;

    while (!slotFinished && curr < data.length) {
      const element = { ...data[curr] };

      element.start_time = quantize(element.start_time, unit, count);
      element.timestamp = element.start_time.valueOf();

      if (element.start_time.isSame(empty.start_time, "hour")) {
        empty.cores += element.cores;
        empty.instance_cost += element.instance_cost;
        empty.license_cost += element.license_cost;
        empty.minutes += element.minutes;
        empty.storage += element.storage;
        empty.storage_cost += element.storage_cost;
        curr += 1;
      } else {
        slotFinished = true;
      }
    }
  });

  return empties;
};

const prepare = (data, unit, count) => {
  if (data.length === 0) {
    return { data, granularity: { unit: "hour", count: 1 } };
  }
  count = parseInt(count, 10);

  if (unit === "auto") {
    const hours = moment
      .duration(data[data.length - 1].start_time.diff(data[0].start_time))
      .asHours();
    const granularity = calculateGranularity(hours, count);
    unit = granularity.unit;
    count = granularity.count;
  }

  const grouped = groupData(data, unit, count);

  return { data: grouped, granularity: { unit, count } };
};

const mapStateToProps = (state, ownProps) => {
  const { data } = state.overview.timeSeries;

  let [unit, count] = state.overview.filters.granularity
    .toLowerCase()
    .split("_");

  const prepared = prepare(data, unit, count);

  return {
    data: prepared.data,
    granularity: prepared.granularity,
    filterState: state.overview.filters,
    loading: state.overview.timeSeries.loading,
    monitoringMode: state.ui.focused
  };
};

const OvTimeViewContainer = connect(mapStateToProps)(OvTimeView);

export default OvTimeViewContainer;



// WEBPACK FOOTER //
// ./src/OvTimeViewContainer.js